import { useAopTopBarFlag } from 'hooks/useFeatureFlag';
import { selectUseAopTopbar } from 'microFrontend/slices/aopUserConfig.slice';
import { useAppSelector } from 'slices/store';

/**
 * Whether to use AOP topbar based on launch darkly flag or local override for root user
 */
export function useAopTopBar() {
  const flag = useAopTopBarFlag();
  const useAop = useAppSelector(selectUseAopTopbar);

  return flag === 'on' || (flag === 'rootOptIn' && useAop);
}
